<template lang="pug">
  .brewing

    .notification.is-warning(v-if="showIOSWarning")
      button.delete(@click='closeIOSWarning')
      p Detected an iOS device - please <strong>leave the browser window open with the device unlocked</strong> during brewing. Due to aggressive power saving in iOS devices, the timer might not ring!

    .controls
      .field
        audio(ref="chime")
          source(src="/chime.mp3")

        input(type="checkbox", v-model="playChime", name="playChime")#playChime.switch.is-small.is-rounded
        label(for="playChime")
          fa-icon(icon='bell')

      .field
        input(type="checkbox", v-model="vibrate", name="vibrate")#vibrate.switch.is-small.is-rounded
        label(for="vibrate")
          img(src='../assets/vibrate.svg' style='height: 1.0rem; width: 1.0rem;').icon

    .subtitle(style="margin-bottom: 0", :class="{'has-text-warning': iInfusion > teaStyleObject.n_infusions}") Brewing - Infusion {{infusion}} {{teaStyleObject.n_infusions === Infinity ? '' : 'of ' + teaStyleObject.n_infusions}}

    .status(v-if="manual") Manual mode {{manual}}
    .status(v-else) {{cup | volume}} of {{teaObject.name}} tea, {{styleObject.name}} style at {{teaObject.temperature | temperature}}.

    div(v-if="iInfusion == 1 || teaStyleObject.infusion_add !== null")
      timer(:duration="infusionTime", @finish="onFinish", @start="onStart" :running.sync="running")
    div(v-else, style="width: 80%; margin: 20px auto").box
      p This tea doesn't need brewing time for subsequent infusions!
      p Simply add more hot water to the tea and immediately pour into your cup.

    .field.has-addons(style="justify-content: flex-end")
      p.control
        router-link(:to="{name: 'Welcome'}").button.is-white.has-text-link Brew something else

      p.control
        router-link(v-if="!manual && iInfusion > 1", :to="{name: 'Brewing', params: {tea: tea, brewStyle: brewStyle, cup: cup, infusion: '' + (iInfusion - 1) }}").button
          span.icon
            fa-icon(icon='angle-left')

        router-link(v-if="manual && iInfusion > 1", :to="{name: manualInfusions === Infinity ? 'BrewingManual' : 'BrewingManualMaxInfusions', params: {manual: manual, infusion: '' + (iInfusion - 1), manualInfusions: manualInfusions }}").button
          span.icon
            fa-icon(icon='angle-left')

      p.control
        router-link(v-if="!manual" :to="{name: 'Brewing', params: {tea: tea, brewStyle: brewStyle, cup: cup, infusion: '' + (iInfusion + 1) }}", :class="{'is-primary': finished}").button
          span Next Infusion
          span.icon
            fa-icon(icon='angle-right')

        router-link(v-if="manual" :to="{name: manualInfusions === Infinity ? 'BrewingManual' : 'BrewingManualMaxInfusions', params: {manual: manual, infusion: '' + (iInfusion + 1), manualInfusions: manualInfusions }}", :class="{'is-primary': finished}").button
          span Next Infusion
          span.icon
            fa-icon(icon='angle-right')

</template>

<script>
import teaData from '../data/teas.json'
import styleData from '../data/styles.json'

import Timer from '@/components/Timer.vue'

export default {
  name: 'Brewing',
  components: { Timer },
  props: {
    tea: {
      type: String,
      default: 'green'
    },
    brewStyle: {
      type: String,
      default: 'gongfu'
    },
    cup: {
      default: 300
    },
    infusion: {
      default: 1
    },
    manual: {
      type: String
    },
    manualInfusions: {
      type: Number,
      default: Infinity
    }
  },
  watch: {
    infusion () {
      this.finished = false
    }
  },
  data () {
    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

    return {
      finished: false,
      playChime: true,
      vibrate: true,
      running: false,
      showIOSWarning: !this.$localStorage.get('iOSWarningClosed', false) && iOS
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.running) {
      const answer = confirm('You are currently brewing something - are you sure you want to leave?')

      if (answer) {
        window.onbeforeunload = null
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  computed: {
    iInfusion () {
      return +this.infusion
    },
    infusionTime () {
      return this.teaStyleObject.infusion_first + (this.iInfusion - 1) * this.teaStyleObject.infusion_add
    },
    teaObject () {
      return teaData[this.tea]
    },
    styleObject () {
      return styleData[this.brewStyle]
    },
    teaStyleObject () {
      if (this.manual) {
        let s = this.manual.split('+')
        let infusionFirst = +s[0]
        let infusionAdd = +s[1]

        if (infusionAdd === 0) {
          infusionAdd = null
        }

        return {
          amount: null,
          infusion_first: infusionFirst,
          infusion_add: infusionAdd,
          n_infusions: this.manualInfusions
        }
      } else {
        return teaData[this.tea].styles[this.brewStyle]
      }
    }
  },
  methods: {
    closeIOSWarning () {
      this.$localStorage.set('iOSWarningClosed', true)
      this.showIOSWarning = false
    },
    onStart () {
      if (this.playChime) {
        let c = this.$refs.chime
        c.volume = 0
        c.currentTime = 0
        c.play().then(() => {
          c.pause()
          c.volume = 1
        })
      }
    },
    onFinish () {
      this.finished = true
      if (this.playChime) {
        this.$refs.chime.play()
      }
      if (this.vibrate) {
        navigator.vibrate(500)
      }
    }
  }
}
</script>
